/* components/ui/QuotaBar.jsx — индикатор использования квоты (used/limit) с
   цветовым порогом: <70% — нейтрально, 70–90% — warn, ≥90% — bad.
   Используется в Базе знаний (файлы и МБ). Данные приходят пропсами.
   ХЕНДОФФ → frontend/components/common/QuotaBar.jsx. */

import { Icon } from './Icon.jsx';

  // дефолтный форматтер числа (целые — без дробей, дробные — 1 знак)
  function defFmt(v) {
    if (v == null || isNaN(v)) return '—';
    return Number.isInteger(v) ? String(v) : v.toFixed(1).replace('.', ',');
  }

  function QuotaBar({ icon, label, used = 0, limit = 0, unit, format, className }) {
    const f = format || defFmt;
    const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
    const tone = pct >= 90 ? 'bad' : pct >= 70 ? 'warn' : 'ok';
    const u = unit ? '\u00A0' + unit : '';
    return (
      <div className={'quota' + (className ? ' ' + className : '')}>
        <div className="quota__head">
          <span className="quota__label">
            {icon && <Icon name={icon} size={14} className="quota__icon" />}
            {label}
          </span>
          <span className="quota__value num">
            {f(used)}{u} <span className="quota__sep">из</span> {f(limit)}{u}
          </span>
        </div>
        <div className={'quota__track quota__track--' + tone} role="progressbar"
          aria-valuenow={used} aria-valuemin={0} aria-valuemax={limit} aria-label={label}>
          <span className="quota__fill" style={{ '--quota-w': pct + '%' }} />
        </div>
      </div>
    );
  }

export { QuotaBar };
